import { render, staticRenderFns } from "./EventUpdate.vue?vue&type=template&id=26513d36&"
import script from "./EventUpdate.vue?vue&type=script&lang=js&"
export * from "./EventUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports